<template>
<div class="d-flex">
    <div
    @click="toggleExpendCorrectRate()" tabindex="0"
        class="exam-status-tab cursor-pointer pdt-4 pdb-4 pdl-8 pdr-8 mgr-4 d-flex align-items-center b-radius4 examRed">
        <img src="/images/file-check-red.svg" class="w-14 h-15 mgr-4">
        <span v-if="correctRateExpend " class="t-helper font-rn">{{$t('1251')}}<span class="pdl-8 pdr-8">{{' | '}}</span> {{$t('1249', {str: correctRate})}}</span>
        <span v-else class="t-helper font-rn"> {{$t('1249', {str: correctRate})}}</span>
        <!-- <span class="t-helper font-rn">{{correctRateExpend ? $t('1251') + ' | ' : ''}} {{$t('1249', {str: correctRate})}}</span> -->
    </div>
    <div
        @click="toggleExpendAvgSolveTimeExpend()" tabindex="0"
        class="exam-status-tab cursor-pointer pdt-4 pdb-4 pdl-8 pdr-8 mgr-4 d-flex align-items-center b-radius4 examGreen">
        <img src="/images/progress-clock.svg" class="w-14 h-15 mgr-4">
        <span v-if="avgSolveTimeExpend" class="t-helper font-rn">{{ $t('1252') }} <span class="pdl-8 pdr-8">{{' | '}}</span> {{$t('1250', {str: avgSolveTime})}}</span>
        <span v-else class="t-helper font-rn">{{$t('1250', {str: avgSolveTime})}}</span>
        <!-- <span class="t-helper font-rn">{{avgSolveTimeExpend ? $t('1252') + ' | ' : ''}} {{$t('1250', {str: avgSolveTime})}}</span> -->
    </div>
    <div
        @click="toggleExpendLevelExpend()" v-if="level" tabindex="0"
        class="exam-status-tab cursor-pointer pdt-4 pdb-4 pdl-8 pdr-8 mgr-4 d-flex align-items-center b-radius4 examBlue">
        <!-- <img src="images/progress-clock.svg" class="w-14 h-15 mgr-4"> -->
        <span v-if="levelExpend" class="t-helper font-rn t-uppercase">{{$t('1253')}} <span class="pdl-8 pdr-8">{{' | '}}</span></span>
        <span else class="t-helper font-rn t-uppercase">{{level}}</span>
        <!-- <span class="t-helper font-rn t-uppercase">{{levelExpend ? $t('1253') + ' | ' : ''}} {{level}}</span> -->
    </div>
</div>
</template>

<script>
// Components/Mixin/Extend/API 선언
/**
 * 문항별 태그 공통 컴포넌트(question tag common component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
   props: ['correctRate', 'avgSolveTime', 'level'],
   data() {
       return {
           correctRateExpend: false,
           avgSolveTimeExpend: false,
           levelExpend: false
       }
   },
   methods: {
       toggleExpendCorrectRate() {
           this.correctRateExpend = !this.correctRateExpend
           this.avgSolveTimeExpend = false;
           this.levelExpend = false;
       },
       toggleExpendAvgSolveTimeExpend() {
           this.avgSolveTimeExpend = !this.avgSolveTimeExpend
           this.levelExpend = false;
           this.correctRateExpend = false;
       },
       toggleExpendLevelExpend() {
           this.levelExpend = !this.levelExpend
           this.correctRateExpend= false;
           this.avgSolveTimeExpend = false;
       }
   }
}
</script>